import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class StoreService {

  findAll(mid, params) {
    return http.get(API_URL + `/v1/stores`, {params: params, headers: authHeader()})
  }

  create(store) {
    return http.post(API_URL + `/v1/stores`, store, {headers: authHeader()});
  }

  update(mid, id, store) {
    return http.put(API_URL + `/v1/stores/${id}`, store, {headers: authHeader()});
  }

  reset(id, data) {
    return http.delete(`${API_URL}/v1/stores/${id}/reset`, {
      headers: authHeader(),
      data: data
    });
  }

  findById(mid, id) {
    return http.get(API_URL + `/v1/stores/${id}`, {headers: authHeader()});
  }

  delete(mid, id) {
    return http.delete(API_URL + `/v1/stores/${id}`, {headers: authHeader()});
  }

  handleResponse(response) {
    return response
  }
}

export default new StoreService();



// WEBPACK FOOTER //
// ./src/service/store.service.js